import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import {auth} from '../../../../Config/Firebase'

import PasswordReset from '../../../Images/PasswordReset.png'

class PasswordResetEmailForm extends Component {
    state = {
        email: '',
        formText: "Send a password reset email.",
        textColor: '#acacac',
        icon: "fas fa-envelope"
    }

    sendPasswordEmail = (event) => {
        event.preventDefault()
    
        auth.sendPasswordResetEmail(this.state.email).then( () =>{
            this.setState({
                formText: "Password Reset Email has been sent.",
                textColor: '#6bb562',
                icon: "fas fa-check-circle"
            })
        })
    }
    
 
    render() { 
        return ( 
            <div className="page">
    
            <div className="container-fluid login-form-div">
            <div className="row">
                <div className="col-xl-6 leftSideLogin">
                    <form className="login-form"onSubmit={(event) => { this.sendPasswordEmail(event) }}>
                        <li>
                        <i style={{fontSize: "60px", color: this.state.textColor}} className={this.state.icon}></i>
                            <h3 style={{color: this.state.textColor}}>{this.state.formText}</h3>
                            <hr/>
                        </li>
                    
                        <li>
                            <input type="email" id="emailInput" placeholder="Email"  onChange={(event) => this.setState({ email: event.target.value})}/>
                        </li>
                        <li>
                            <button type="submit"className="btn btn-primary large">Send</button>
                        </li>
                        <li id="bottom-nav"><a onClick={this.props.showLogin}>Back to Login</a><span> | </span><Link to="/">Back to Westhaven</Link></li>
                    </form>
            
                </div>
                <div className="d-none d-lg-block col-xl-6 rightSideLogin">
                            <div className="rightPanelDiv">
                                    <img src={PasswordReset} alt="Image of MyHaven" width="400px"/>
                                </div>
                            </div>

            </div>
        </div>

        </div>
         )
    }
}
 
export default PasswordResetEmailForm;


// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/LoginPage/PasswordResetEmailForm.jsx